type Path = string | Array<string | number>;
type Options = {
    insertAsObject: boolean;
};

type BaseSetFunctionType = {
    <T extends object>(obj: T, path: Path, value: any, options?: Options): T;
    <ReturnType>(obj: object, path: Path, value: any, options?: Options): ReturnType;
};

type SetFunctionType = {
    <T extends object>(obj: T, path: Path, value: any): T;
    <ReturnType>(obj: object, path: Path, value: any): ReturnType;
};

export const baseSet: BaseSetFunctionType = <T extends object>(
    obj: T,
    path: Path,
    value: any,
    options?: Options,
): T => {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }

    const { insertAsObject = false } = options ?? {};
    const pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])+/g) || [''];

    pathArray.reduce((acc, key, index) => {
        // @ts-expect-error unknown key of object
        if (acc[key] === undefined || acc[key] === null) {
            const nextKeyAsNumber = Number.parseInt(`${pathArray[index + 1]}`, 10);

            // @ts-expect-error unknown key of object
            acc[key] =
                Number.isFinite(nextKeyAsNumber) && nextKeyAsNumber >= 0 && !insertAsObject
                    ? []
                    : {};
        }

        if (index === pathArray.length - 1) {
            // @ts-expect-error unknown key of object
            acc[key] = value;
        }

        // @ts-expect-error unknown key of object
        return acc[key];
    }, obj);

    return obj;
};

export const set: SetFunctionType = <T extends object>(obj: T, path: Path, value: any): T =>
    baseSet(obj, path, value);

export const setWithObject: SetFunctionType = <T extends object>(
    obj: T,
    path: Path,
    value: any,
): T => baseSet(obj, path, value, { insertAsObject: true });
